import script from "./DueDiligenceElement.vue?vue&type=script&setup=true&lang=js"
export * from "./DueDiligenceElement.vue?vue&type=script&setup=true&lang=js"

import "./DueDiligenceElement.vue?vue&type=style&index=0&id=5c0ab166&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c0ab166"]])

export default __exports__